import ErrorBasePage from "./ErrorBasePage";

export interface ErrorPageLocationState {
  errorMessage?: string;
}

export const ErrorPage = () => {
  return <ErrorBasePage />;
};
